module.exports = __webpack_public_path__ + "img/T2D_xh_9.812c0bef.png";